/**
 * 将模型可能返回的字符串或字符串数组统一为可展示数组。
 *
 * @param {unknown} values 模型返回的单条文本或文本数组。
 * @returns {Array<string>} 去除空项后的文本数组。
 */
export function normalizeStringList(values) {
  const source = Array.isArray(values) ? values : (typeof values === "string" ? values.split(/\r?\n+/) : []);
  return source
    .map((value) => String(value ?? "").trim().replace(/^(?:[-*\u2022]\s*|\d+[.)、]\s*)/, ""))
    .filter(Boolean);
}

/**
 * 按回答顺序读取模型逐轮反馈，并兼容缺失的反馈数组。
 *
 * @param {object} result IELTS 评分结果。
 * @param {number} answerIndex 从零开始的回答序号。
 * @returns {{problems_zh:Array<string>,suggestions_zh:Array<string>,improved_answer:string}} 归一化后的逐轮反馈。
 */
export function feedbackForAnswer(result, answerIndex) {
  const feedback = Array.isArray(result?.turn_feedback)
    ? result.turn_feedback.find((item, index) => Number(item?.turn_number || index + 1) === answerIndex + 1)
    : null;
  return {
    problems_zh: normalizeStringList(feedback?.problems_zh),
    suggestions_zh: normalizeStringList(feedback?.suggestions_zh),
    improved_answer: String(feedback?.improved_answer || "").trim(),
  };
}
